// import './assets/main.css'

// Polyfills for supporting older browsers (.at() method)
import 'core-js/features/array/at'

// var compatibleBrowser = typeof Object['__defineSetter__'] === 'function'
// if (!compatibleBrowser) {
//   const root = document.getElementById('app')
//   if (root) {
//     root.innerHTML = `
//       <div style="padding:2rem; text-align:center; font-family:sans-serif">
//         <h1>Unsupported Browser</h1>
//         <p>
//           Sorry, this web app requires a more modern browser.<br/>
//           Please upgrade to the latest version of Chrome, Firefox, Edge, or Safari.
//         </p>
//       </div>
//     `
//   }
//   throw new Error('Unsupported browser')
// }

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from '@/router'

import resetStore from '@/plugins/resetStore'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import vuetify from '@/plugins/vuetify'

import * as Sentry from '@sentry/vue'

import '@vuepic/vue-datepicker/dist/main.css'
import LoadScript from 'vue-plugin-load-script'
import { CONFIG } from '@/config'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
pinia.use(resetStore)

app.use(pinia)
app.use(vuetify)
app.use(router)
app.use(LoadScript)

Sentry.init({
  app,
  dsn: `${CONFIG.SENTRY_DSN}`,
  environment: `${CONFIG.RUNNING_IN_ENV}`,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets:
    `${CONFIG.RUNNING_IN_ENV}` === 'development'
      ? ['localhost']
      : [CONFIG.API_BASE_URL, /fieldhockeybc.ca/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.mount('#app')
